import { AppConfig } from '@inpart-io/devtools';

export const trackConfig = new AppConfig();

export const trackOtherConfig: { enabled: boolean; webClientBaseUrl: string; tenant: string } = { enabled: false, webClientBaseUrl: null, tenant: null };
